module.exports = __webpack_public_path__ + "img/losing-muscle.4f18e6bd.svg";